export default ()=>{return {
    en:{"Kuvendi":"Parliament",
    "Struktura":"Structures",

}
}}